import React, { useState, useEffect, Fragment } from "react";
import localization from "assets/localization/localization";
import DivLayout from "components/sales/divLayout/divLayout";
import Layout from "components/sales/layout/layout";
const AddressBusinessListing = ({
  match,
  history,
  getBusinessAddressDetails,
  businessAddressListing,
}) => {
  // console.log("PAGE::ADDRESS-DETAILS" + JSON.stringify(clientAddressListing));
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    if (businessAddressListing != null) {
      setData(businessAddressListing);
    }
  }, [businessAddressListing]);

  useEffect(() => {
    if (
      getBusinessAddressDetails != null &&
      match.params.lead_id != undefined
    ) {
      (async () => {
        setIsLoading(true);
        await getBusinessAddressDetails(match.params.lead_id);
        setIsLoading(false);
      })();
    }
  }, [getBusinessAddressDetails, match.params.lead_id]);
  return (
    <Layout title={localization.addressDetails} isGoback isLoading={isLoading}>
      {data?.length > 0 ? (
        <>
          {data.map((item, key) => (
            <>
              <div className="panel-card">
                <div className="panel-heading">
                  {"Address " + (key+1) }
                </div>
                <div className="panel-body">
                  <div className="details-listing">
                    <DivLayout
                      heading={`POC Name`}
                      data={item["name"]}
                    ></DivLayout>
                    <DivLayout
                      heading={`Email`}
                      data={item["email"]}
                    ></DivLayout>
                    <DivLayout
                      heading={`Client GST`}
                      data={item["client_gst"]}
                    ></DivLayout>
                    <DivLayout
                      heading={`State`}
                      data={item["state_name"]}
                    ></DivLayout>
                    <DivLayout
                      heading={`City`}
                      data={item["city_name"]}
                    ></DivLayout>
                    <DivLayout
                      heading={`Pincode`}
                      data={item["pincode"]}
                    ></DivLayout>
                    <DivLayout
                      heading={`Address Line 1`}
                      data={item["address_line_1"]}
                    ></DivLayout>
                    <DivLayout
                      heading={`Address Line 2`}
                      data={item["address_line_2"]}
                    ></DivLayout>
                    <DivLayout
                      heading={`Recon Address Id`}
                      data={item["recon_lead_address_id"]}
                    ></DivLayout>
                  </div>
                </div>
              </div>
            </>
          ))}
        </>
      ) : null}
    </Layout>
  );
};

export default AddressBusinessListing;
